module.exports = __webpack_public_path__ + "186d2d60ca69cf674769a2021221fdd5.png";